// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__25VR_"};